import React from "react";

const LockedIcon = ({ color = "#8F8F8F" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="red"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4V5H9V4C9 3.73736 8.94827 3.47728 8.84776 3.23463C8.74725 2.99198 8.59993 2.7715 8.41421 2.58579C8.2285 2.40007 8.00802 2.25275 7.76537 2.15224C7.52272 2.05173 7.26264 2 7 2ZM3 4V5C2.60218 5 2.22064 5.15803 1.93934 5.43934C1.65804 5.72064 1.5 6.10218 1.5 6.5V12.5C1.5 12.697 1.5388 12.892 1.61418 13.074C1.68956 13.256 1.80005 13.4214 1.93934 13.5607C2.07863 13.6999 2.24399 13.8104 2.42597 13.8858C2.60796 13.9612 2.80302 14 3 14H11C11.3978 14 11.7794 13.842 12.0607 13.5607C12.342 13.2794 12.5 12.8978 12.5 12.5V6.5C12.5 6.10218 12.342 5.72064 12.0607 5.43934C11.7794 5.15803 11.3978 5 11 5V4C11 2.93913 10.5786 1.92172 9.82843 1.17157C9.07828 0.421427 8.06087 0 7 0C5.93913 0 4.92172 0.421427 4.17157 1.17157C3.42143 1.92172 3 2.93913 3 4ZM7 10.75C7.33152 10.75 7.64946 10.6183 7.88388 10.3839C8.1183 10.1495 8.25 9.83152 8.25 9.5C8.25 9.16848 8.1183 8.85054 7.88388 8.61612C7.64946 8.3817 7.33152 8.25 7 8.25C6.66848 8.25 6.35054 8.3817 6.11612 8.61612C5.8817 8.85054 5.75 9.16848 5.75 9.5C5.75 9.83152 5.8817 10.1495 6.11612 10.3839C6.35054 10.6183 6.66848 10.75 7 10.75Z"
        fill={color}
      />
    </svg>
  );
};

export default LockedIcon;
